module.exports = __webpack_public_path__ + "assets/PtSymmetryDetailed.40e648b4d1f0b65bf6075968b1e96c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/PtSymmetryDetailed.png
// module id = 552
// module chunks = 0